import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { CardProductProps } from '~/components/UI/CardProduct'
import SliderProducts from '~/components/UI/SliderProducts'

import { useStyle } from '~/providers/StyleProvider'

import useTrackProductCardsList from '~/hooks/tracking/useTrackProductCardsList'

import { PRODUCT } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)
interface ProductRecommendationsProps {
  className?: string
  items?: CardProductProps[]
}
export function ProductRecommendations({
  className,
  items,
}: ProductRecommendationsProps) {
  const t = useTranslate()
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  const titleStyle = useStyle({
    color: GlobalThemeColors.Black,
    textPreset: GlobalTextPreset.Title16Primary,
    textStyling: GlobalTextStyling.UpperCase,
  })
  const [setRef, handleItemTracker] = useTrackProductCardsList(
    `product-page-recommandations`,
    items,
  )

  return (
    <div className={cx(css.ProductRecommendations, gridStyle)} ref={setRef}>
      <div className={cx(css.title, titleStyle)}>
        {t(PRODUCT.RECOMMENDATIONS)}
      </div>
      <SliderProducts
        className={cx(css.sliderContainer)}
        withArrows
        sliderClassName={cx(css.slider)}
        handleItemTracker={handleItemTracker}
        layout="m"
        arrowsTheme={GlobalThemeColors.Black}
        items={items}
      />
    </div>
  )
}
